var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37656 2.6375C7.94933 2.14976 7.71388 1.5234 7.71406 0.875H5.78281V8.625C5.76792 9.04439 5.59086 9.44164 5.28892 9.73309C4.98697 10.0245 4.58372 10.1874 4.16406 10.1875C3.27656 10.1875 2.53906 9.4625 2.53906 8.5625C2.53906 7.4875 3.57656 6.68125 4.64531 7.0125V5.0375C2.48906 4.75 0.601562 6.425 0.601562 8.5625C0.601562 10.6438 2.32656 12.125 4.15781 12.125C6.12031 12.125 7.71406 10.5312 7.71406 8.5625V4.63125C8.49719 5.19366 9.43741 5.4954 10.4016 5.49375V3.5625C10.4016 3.5625 9.22656 3.61875 8.37656 2.6375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.bec6e6c01c12b0701b7cd0386385b61c.svg";
export { ForwardRef as ReactComponent };